import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <footer className="bg-black text-white py-16 px-6 md:px-12 lg:px-24" data-id="element-585">
      <div className="max-w-7xl mx-auto" data-id="element-586">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-587">
          {/* Logo and Description */}
          <div className="md:col-span-1" data-id="element-588">
            <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8 mb-4 brightness-0 invert" data-id="element-589" />
            <p className="text-sm text-gray-400 leading-relaxed" data-id="element-590">
              The Contextual Intelligence Company.
            </p>
          </div>

          {/* Solutions - FIXED ORDER TO MATCH NAVIGATION */}
          <div data-id="element-591">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-592">
              Solutions
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-593">
              <li data-id="element-594">
                <Link to="/the-instruction-layer" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-595">
                  The Instruction Layer
                </Link>
              </li>
              <li data-id="element-596">
                <Link to="/context-engineering" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-597">
                  Context Engineering
                </Link>
              </li>
              <li data-id="element-598">
                <Link to="/how-it-works" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-599">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-600">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-601">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-602">
              <li data-id="element-603">
                <Link to="/about" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-604">
                  About Synthia
                </Link>
              </li>
              <li data-id="element-605">
                <Link to="/blog" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-606">
                  Blog
                </Link>
              </li>
              <li data-id="element-607">
                <Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-608">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-609">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-610">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-611">
              <li data-id="element-612">
                <Link to="/terms" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-613">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-614">
                <Link to="/privacy" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-615">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-616">
          <p className="text-sm text-gray-500" data-id="element-617">
            © 2026 meetsynthia.ai, Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-618">
            <a href="https://www.linkedin.com/company/meetsynthia-ai/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-619">
              LinkedIn
            </a>
            <a href="https://x.com/meetsynthiaAI" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-620">
              X
            </a>
          </div>
        </div>
      </div>
    </footer>;
}